import Airtable from "airtable";

const base = new Airtable({
  apiKey: "key0ouZmQ460rWSz2",
}).base("appLPOjDalXKTH4T0");

export default base;
